module.exports = __webpack_public_path__ + "img/401.a6bcc035.gif";